import {toUserKey} from "./apiUtils";

export const getMessageSender = (message, users) => {
    if (!message.sender) {
        return null;
    }

    return users?.find(user => user.pk === message.sender);
}